/*
 * Name : page_factory.js
 * Description: Motherhouse Factory Page Indivisual Script
 *
 * 1. Lazy Load
 *
 *
 */

/*--------------------------
Lazy Load
--------------------------*/
window.addEventListener("DOMContentLoaded", () => {
  $(function () {
    var height = $(window).height();

    $(window).scroll(function () {
      var y = $(window).scrollTop();
      var windowH = $(window).height();

      $(".factory_section").each(function (i) {
        i = i + 1;
        var y = $(window).scrollTop();
        var windowH = $(window).height();

        if (
          $(this).hasClass("block_factory_indonesia") ||
          $(this).hasClass("block_factory_srilanka") ||
          $(this).hasClass("block_factory_india") ||
          $(this).hasClass("block_factory_myanmar") ||
          $(this).hasClass("block_factory_nepal")
        ) {
          var scalepercent =
            (y - $(this).offset().top) /
              ($(this).offset().top + $(this).height() - $(this).offset().top) /
              1 +
            0.78;
        } else if ($(this).hasClass("block_factory_bangladesh")) {
          var scalepercent =
            (y - $(this).offset().top) /
              ($(this).offset().top + $(this).height() - $(this).offset().top) /
              1 +
            0.8;
        } else {
          var scalepercent =
            (y - $(this).offset().top) /
              ($(this).offset().top + $(this).height() - $(this).offset().top) /
              1 +
            0.87;
        }

        if (
          $(this).hasClass("block_factory_indonesia") ||
          $(this).hasClass("block_factory_srilanka") ||
          $(this).hasClass("block_factory_india") ||
          $(this).hasClass("block_factory_myanmar") ||
          $(this).hasClass("block_factory_nepal")
        ) {
          if (y > $(this).offset().top) {
            if (scalepercent < 1) {
              $(".sp_content-" + i + " .mask").removeClass("active");
              $(".sp_content-" + i + " .item img").css({
                WebkitTransform: "scale(" + scalepercent + ")",
              });
              $(".sp_content-" + i + " .item img").css({
                MozTransform: "scale(" + scalepercent + ")",
              });
              $(".sp_content-" + i + " .item img").css({
                OTransform: "scale(" + scalepercent + ")",
              });
              $(".sp_content-" + i + " .item img").css({
                msTransform: "scale(" + scalepercent + ")",
              });
            } else if (scalepercent >= 1) {
              $(".sp_content-" + i).addClass("active");
              $(".sp_content-" + i + " .mask").addClass("active");
              $(".sp_content-" + i + " .item img").css({
                WebkitTransform: "scale(" + 1 + ")",
              });
              $(".sp_content-" + i + " .item img").css({
                MozTransform: "scale(" + 1 + ")",
              });
              $(".sp_content-" + i + " .item img").css({
                OTransform: "scale(" + 1 + ")",
              });
              $(".sp_content-" + i + " .item img").css({
                msTransform: "scale(" + 1 + ")",
              });
            }
          } else {
            $(".sp_content-" + i).removeClass("active");
            $(".sp_content-" + i + " .item img").css({
              WebkitTransform: "scale(" + 0.78 + ")",
            });
            $(".sp_content-" + i + " .item img").css({
              MozTransform: "scale(" + 0.78 + ")",
            });
            $(".sp_content-" + i + " .item img").css({
              OTransform: "scale(" + 0.78 + ")",
            });
            $(".sp_content-" + i + " .item img").css({
              msTransform: "scale(" + 0.78 + ")",
            });
          }
        } else if ($(this).hasClass("block_factory_bangladesh")) {
          if (y > $(this).offset().top) {
            if (scalepercent < 1) {
              $(".sp_content-" + i + " .mask").removeClass("active");
              $(".sp_content-" + i + " .item img").css({
                WebkitTransform: "scale(" + scalepercent + ")",
              });
              $(".sp_content-" + i + " .item img").css({
                MozTransform: "scale(" + scalepercent + ")",
              });
              $(".sp_content-" + i + " .item img").css({
                OTransform: "scale(" + scalepercent + ")",
              });
              $(".sp_content-" + i + " .item img").css({
                msTransform: "scale(" + scalepercent + ")",
              });
            } else if (scalepercent >= 1) {
              $(".sp_content-" + i).addClass("active");
              $(".sp_content-" + i + " .mask").addClass("active");
              $(".sp_content-" + i + " .item img").css({
                WebkitTransform: "scale(" + 1 + ")",
              });
              $(".sp_content-" + i + " .item img").css({
                MozTransform: "scale(" + 1 + ")",
              });
              $(".sp_content-" + i + " .item img").css({
                OTransform: "scale(" + 1 + ")",
              });
              $(".sp_content-" + i + " .item img").css({
                msTransform: "scale(" + 1 + ")",
              });
            }
          } else {
            $(".sp_content-" + i).removeClass("active");
            $(".sp_content-" + i + " .item img").css({
              WebkitTransform: "scale(" + 0.8 + ")",
            });
            $(".sp_content-" + i + " .item img").css({
              MozTransform: "scale(" + 0.8 + ")",
            });
            $(".sp_content-" + i + " .item img").css({
              OTransform: "scale(" + 0.8 + ")",
            });
            $(".sp_content-" + i + " .item img").css({
              msTransform: "scale(" + 0.8 + ")",
            });
          }
        } else {
          if (y > $(this).offset().top) {
            if (scalepercent < 1) {
              $(".sp_content-" + i + " .mask").removeClass("active");
              $(".sp_content-" + i + " .item img").css({
                WebkitTransform: "scale(" + scalepercent + ")",
              });
              $(".sp_content-" + i + " .item img").css({
                MozTransform: "scale(" + scalepercent + ")",
              });
              $(".sp_content-" + i + " .item img").css({
                OTransform: "scale(" + scalepercent + ")",
              });
              $(".sp_content-" + i + " .item img").css({
                msTransform: "scale(" + scalepercent + ")",
              });
            } else if (scalepercent >= 1) {
              $(".sp_content-" + i).addClass("active");
              $(".sp_content-" + i + " .mask").addClass("active");
              $(".sp_content-" + i + " .item img").css({
                WebkitTransform: "scale(" + 1 + ")",
              });
              $(".sp_content-" + i + " .item img").css({
                MozTransform: "scale(" + 1 + ")",
              });
              $(".sp_content-" + i + " .item img").css({
                OTransform: "scale(" + 1 + ")",
              });
              $(".sp_content-" + i + " .item img").css({
                msTransform: "scale(" + 1 + ")",
              });
            }
          } else {
            $(".sp_content-" + i).removeClass("active");
            $(".sp_content-" + i + " .item img").css({
              WebkitTransform: "scale(" + 0.87 + ")",
            });
            $(".sp_content-" + i + " .item img").css({
              MozTransform: "scale(" + 0.87 + ")",
            });
            $(".sp_content-" + i + " .item img").css({
              OTransform: "scale(" + 0.87 + ")",
            });
            $(".sp_content-" + i + " .item img").css({
              msTransform: "scale(" + 0.87 + ")",
            });
          }
        }
      });
    });

    var $image = $("img.js_lazy");
    $image.show().lazyload({
      threshold: 20,
      effect: "fadeIn",
      effectspeed: 1000,
    });

    $(".jsc_fade_parent").waypoint(
      function (direction) {
        var activePoint = $(this.element);
        if (direction === "down") {
          activePoint.addClass("active");
          setTimeout(function () {
            activePoint
              .parent()
              .parent()
              .find(".jsc_fade_child")
              .addClass("active");
          }, 300);
          setTimeout(function () {
            activePoint.next(".jsc_fade_second").addClass("active");
          }, 800);
        }
      },
      {
        offset: "70%",
      }
    );

    function targetCu() {
      var margin = 50, //ウインドウ上部からどれぐらいの位置で変化させるか
        sectionTop = new Array(), //sectionのTop位置格納用
        current = -1; //現在のカレント位置
      //(1)各targetの縦位置を取得
      $(".factory_section").each(function (i) {
        sectionTop[i] = $(this).offset().top;
      });
      //init
      changeNavCurrent(0);
      //スクロールした時の処理
      $(window).scroll(function () {
        scrollY = $(window).scrollTop();
        //(2)各targetの位置とスクロール位置を比較して、条件にあったらchangeNavCurrentを実行
        for (var i = sectionTop.length - 1; i >= 0; i--) {
          if (scrollY > sectionTop[i] - margin) {
            changeNavCurrent(i);
            break;
          }
        }
      });
      //(3)ナビの処理
      function changeNavCurrent(curNum) {
        if (curNum != current) {
          current = curNum;
          curNum2 = curNum + 1; //HTML順序用
          $(".page_navi li").removeClass("active");
          $(".page_navi li:nth-child(" + curNum2 + ")").addClass("active");
        }
      }
    }

    //ファンクション実行
    $(window).load(function () {
      targetCu();
    });
    var timer = false;
    //リサイズ時ファンクション再実行
    $(window).resize(function () {
      if (timer !== false) {
        clearTimeout(timer);
      }
      timer = setTimeout(function () {
        targetCu();
      }, 200);
    });
  });

  //ページ内スムーズスクロール
  $(function () {
    $(".js-scroll[href^=#]").click(function () {
      var speed = 500;
      var href = $(this).attr("href");
      var target = $(href == "#" || href == "" ? "html" : href);
      var position = target.offset().top;
      $("html, body").animate({ scrollTop: position }, speed, "swing");
      return false;
    });
  });

  //ナビ固定
  $(function () {
    var target = $(".block_factory_bangladesh");
    var offset = target.offset();
    var windowH = $(window).height();
    $(window).scroll(function () {
      if ($(window).scrollTop() > offset.top - (windowH - 300)) {
        $(".page_navi").addClass("active");
      } else {
        $(".page_navi").removeClass("active");
      }
    });
  });
});
